// Set to the official logo path (e.g. "/brand/logo-bdc.png" in /public) to replace the typographic logo everywhere.
export const LOGO_SRC = null;
export const LOGO_ALT = "BDC-Boutique by La Bottega del Calzolaio – Foggia";

export const BUSINESS = {
  brand: "BDC-Boutique",
  domain: "bdcboutique.it",
  legalName: "LA BOTTEGA DEL CALZOLAIO DI PICCIRILLI LUIGI",
  legalForm: "impresa individuale",
  legalSeat: "Via Guido D'Orso 77, 71122 Foggia (FG), Italia",
  cf: "PCCLGU73C14D643Q",
  rea: "FG-337947",
  pec: "bottegapiccirilli@pec.it",
  address: "Via Guido D'Orso 77/79",
  city: "71122 Foggia (FG), Italia",
  phone: "+39 324 694 1767",
  phoneHref: "tel:+393246941767",
  email: "bottegadelcalzolaio@blu.it",
  vat: "04551700711",
  owner: "Piccirilli Luigi",
  hours: [{ days: "Lunedì – Venerdì", time: "08:30 – 13:00 · 16:30 – 20:00" }],
  mapsHref: "https://www.google.com/maps/search/?api=1&query=Via+Guido+D'Orso+77+71122+Foggia",
  social: [
    { id: "facebook", label: "Facebook", href: "https://facebook.com/264581650563691" },
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/labottegadelcalzolaiofoggia" },
    { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@bottegadelcalzolaio" },
  ],
};
